module.exports = __webpack_public_path__ + "img/col2.6899d3ab.webp";